import { config } from '../../config';

/** Where a category's icon can be previewed from: the uploaded SVG, else the key bundled with the web app. */
export const categoryIconSrc = (category) => {
    if (category?.iconUrl) return category.iconUrl;
    if (category?.icon) return `${config().clientBaseUrl}/static/assets/icons/categories/${category.icon}.svg`;
    return null;
};
